import React, { FunctionComponent } from 'react';
import { Box, Button } from '@material-ui/core';
import transferActionsStyles from './transferActionsStyles';
import Translation from '../../../../common/components/translation/Translation';

export interface ITransferActionsProps {
  onDeclineTransfer: () => void;
  onAcceptTransfer: () => void;
  onlyInvalidOptions: boolean;
}

const TransferActions: FunctionComponent<ITransferActionsProps> = ({
  onDeclineTransfer,
  onAcceptTransfer,
  onlyInvalidOptions,
}) => {
  const styles = transferActionsStyles();

  return (
    <Box className={styles.container}>
      {!onlyInvalidOptions && (
        <Button
          variant="contained"
          color={'primary'}
          className={styles.button}
          onClick={onAcceptTransfer}
          data-test="stock:transfer:accept_transfer"
        >
          <Translation id="trans__configurator__stock__transfer_modal_transfer_CTA" />
        </Button>
      )}
      <Button
        variant={onlyInvalidOptions ? 'contained' : 'outlined'}
        color={'secondary'}
        className={styles.button}
        onClick={onDeclineTransfer}
        data-test={onlyInvalidOptions ? 'stock:transfer:continue' : 'stock:transfer:decline_transfer'}
      >
        <Translation
          id={`${
            onlyInvalidOptions
              ? 'trans__configurator__stock__transfer_modal_transfer_CTA'
              : 'trans__configurator__stock__transfer_modal_no_transfer_CTA'
          }`}
        />
      </Button>
    </Box>
  );
};

export default TransferActions;
